export default "__VITE_ASSET__DZpYy1KA__"